import { m } from "../../paraglide/messages.js";

/** The six sections of the account, each a screen of its own on a phone. */
export const accountSections = ["practice", "instagram", "billing", "notifications", "security", "data"] as const;

export type AccountSection = (typeof accountSections)[number];

export const sectionWordings: Record<AccountSection, { title: () => string; summary: () => string }> = {
  practice: { title: m.account_section_practice, summary: m.account_section_practice_summary },
  instagram: { title: m.account_section_instagram, summary: m.account_section_instagram_summary },
  billing: { title: m.account_section_billing, summary: m.account_section_billing_summary },
  notifications: { title: m.account_section_notifications, summary: m.account_section_notifications_summary },
  security: { title: m.account_section_security, summary: m.account_section_security_summary },
  data: { title: m.account_section_data, summary: m.account_section_data_summary },
};

/** The section the address names, if it names one. */
export function validateSectionSearch(search: Record<string, unknown>): { section?: AccountSection } {
  const section = accountSections.find((value) => value === search["section"]);
  return section === undefined ? {} : { section };
}
